module.exports = __webpack_public_path__ + "img/RedBullPatternWave.e2938114.svg";